import React, { forwardRef, useImperativeHandle } from 'react';
import PropTypes from 'prop-types';

import V3OfferDealTermsPaneBody from './V3OfferDealTermsPaneBody';
import '../styles/lineup.css';

// Right-hand deal-terms pane. Thin wrapper around V3OfferDealTermsPaneBody
// that keeps the desktop outer <section> chrome and the imperative-handle
// shim. Mobile renders V3OfferDealTermsPaneBody directly.
const V3OfferDealTermsPane = forwardRef((props, ref) => {
  useImperativeHandle(ref, () => ({
    expandMore: () => {},
    openContacts: () => {},
  }), []);

  return (
    <section className="deal-terms-pane">
      <V3OfferDealTermsPaneBody {...props} showToolbar />
    </section>
  );
});

V3OfferDealTermsPane.displayName = 'V3OfferDealTermsPane';

V3OfferDealTermsPane.propTypes = {
  team: PropTypes.object.isRequired,
  offer: PropTypes.object.isRequired,
  budget: PropTypes.object,
  confirm: PropTypes.object,
  currentUser: PropTypes.object,
  csrfToken: PropTypes.string.isRequired,
  actType: PropTypes.string,
  onPreview: PropTypes.func.isRequired,
  onCopy: PropTypes.func.isRequired,
  onDownload: PropTypes.func.isRequired,
  onCreateHold: PropTypes.func,
  onCreateConfirm: PropTypes.func,
  canConfirm: PropTypes.bool,
  onDelete: PropTypes.func.isRequired,
  onSend: PropTypes.func.isRequired,
  onAddContact: PropTypes.func,
  onChangeActType: PropTypes.func.isRequired,
  bonusManagerProps: PropTypes.object,
  walkoutPotential: PropTypes.number,
  onEditPerformer: PropTypes.func,
  offerContacts: PropTypes.array,
  offerContactsChanged: PropTypes.func,
  contactsDefaultOpen: PropTypes.bool,
  calculated: PropTypes.object,
};

V3OfferDealTermsPane.defaultProps = {
  budget: null,
  confirm: null,
  currentUser: null,
  actType: null,
  onCreateHold: null,
  onCreateConfirm: null,
  canConfirm: false,
  onAddContact: null,
  bonusManagerProps: null,
  walkoutPotential: 0,
  onEditPerformer: null,
  offerContacts: [],
  offerContactsChanged: null,
  contactsDefaultOpen: false,
  calculated: null,
};

export default V3OfferDealTermsPane;
